<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{'show': shallShowUserProfileSidebar || shallShowActiveChatContactSidebar || mqShallShowLeftSidebar}"
      @click="mqShallShowLeftSidebar=shallShowActiveChatContactSidebar=shallShowUserProfileSidebar=false"
    />

    <!-- Main Area -->
    <section class="chat-app-window">

      <!-- Start Chat Logo -->
      <div
        v-if="!$store.state.chat.activeRoom"
        class="start-chat-area"
      >
        <div class="mb-1 start-chat-icon">
          <feather-icon
            icon="MessageSquareIcon"
            size="56"
          />
        </div>
        <h4
          class="sidebar-toggle"
          @click="startConversation"
        >
          Chat (MIA)
        </h4>
      </div>

      <!-- Chat Content -->
      <div
        v-else
        class="active-chat"
      >
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">

            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">

              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>

              <b-avatar
                size="36"
                :src="linkStaging($store.state.chat.activeRoom.user_1.photo_url, 36, 36)"
                class="mr-1 cursor-pointer badge-minimal"
                badge
                :text="avatarText($store.state.chat.activeRoom.user_1.name)"
                variant="primary"
                @click.native="shallShowActiveChatContactSidebar=true"
              />
              <h6 class="mb-0">
                {{ $store.state.chat.activeRoom.user_1.name }}
              </h6>
            </div>

            <!-- Contact Actions -->
            <div class="d-flex align-items-center">
              <div class="dropdown">
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="17"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item>
                    View Contact
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Mute Notifications
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Block Contact
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Clear Chat
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Report
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </header>
        </div>

        <!-- User Chat Area -->
        <vue-perfect-scrollbar
          ref="refChatLogPS"
          :settings="perfectScrollbarSettings"
          class="user-chats scroll-area"
        >
          <chat-log
            :chat-data="activeChat"
            :profile-user-avatar="profileUserDataMinimal.avatar"
            :is-friend-typing="otherTypingUsers.findIndex(item => $store.state.chat.activeRoom && item.id === $store.state.chat.activeRoom.user_1.id) !== -1"
            @cancel-reply="cancelReply"
          />
        </vue-perfect-scrollbar>

        <!-- Message Input -->
        <b-form
          class="chat-app-form"
          @submit.prevent="send"
        >
          <b-input-group class="input-group-merge form-send-message mr-1">
            <b-form-input
              v-model="text"
              placeholder="Enter your message"
              @input="sendTypingEvent"
            />
          </b-input-group>
          <b-button
            variant="primary"
            type="submit"
          >
            Send
          </b-button>
        </b-form>
      </div>
    </section>

    <!-- Active Chat Contact Details Sidebar -->
    <chat-active-chat-content-details-sidedbar
      :shall-show-active-chat-contact-sidebar.sync="shallShowActiveChatContactSidebar"
      :contact="activeChat.contact || {}"
    />

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <chat-left-sidebar
        :other-typing-users="otherTypingUsers"
        :chats-contacts="chatsContacts"
        :contacts="contacts"
        :active-chat-contact-id="activeChat.contact ? activeChat.contact.id : null"
        :shall-show-user-profile-sidebar.sync="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        :profile-user-minimal-data="profileUserDataMinimal"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        @show-user-profile="showUserProfileSidebar"
        @open-chat="openChatOfContact"
      />
    </portal>
  </div>
</template>

<script>
import store from '@/store'
import {
  ref, onUnmounted,
} from '@vue/composition-api'
import {
  BAvatar, BDropdown, BDropdownItem, BForm, BInputGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import { formatDate } from '@core/utils/filter'
import { $themeBreakpoints } from '@themeConfig'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
import Pusher from 'pusher-js'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { v4 as uuidv4 } from 'uuid'
import ChatLeftSidebar from './ChatLeftSidebar.vue'
import chatStoreModule from './chatStoreModule'
import ChatActiveChatContentDetailsSidedbar from './ChatActiveChatContentDetailsSidedbar.vue'
import ChatLog from './ChatLog.vue'
import useChat from './useChat'

export default {
  components: {
    // BSV
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,

    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    ChatLeftSidebar,
    ChatActiveChatContentDetailsSidedbar,
    ChatLog,
  },
  data() {
    return {
      avatarText,

      socket: null,
      channel: null,
      channelAllChat: null,
      pendingChat: null,
      timeout: null,

      otherTypingUsers: [],
    }
  },
  computed: {
    activeRoom() {
      return this.$store.state.chat.activeRoom
    },
  },
  watch: {
    activeRoom() {
      this.sendOfflineStatus()
      this.subscribeChannel()
    },
  },
  mounted() {
    this.$store.dispatch('chat/getRooms')
    this.subscribeChannelAllChat()
    this.startOnlineStatus()

    document.addEventListener('visibilitychange', this.checkVisibility)
  },
  beforeDestroy() {
    this.sendOfflineStatus()
    clearTimeout(this.timeout)
    document.removeEventListener('visibilitychange', this.checkVisibility)
  },
  methods: {
    checkVisibility() {
      if (document.visibilityState === 'visible') {
        this.startOnlineStatus()
      } else {
        this.sendOfflineStatus()
      }
    },
    startOnlineStatus() {
      if (this.$store.state.chat.activeRoom) {
        this.sendOnlineEvent()
      }

      this.timeout = setTimeout(() => {
        this.startOnlineStatus()
      }, 1000)
    },
    sendOnlineEvent() {
      if (this.channel) {
        this.channel.trigger('client-admin-online', {})
      }
    },
    sendOfflineStatus() {
      if (this.channel) {
        this.channel.trigger('client-admin-offline', {})
      }
    },
    async subscribeChannelAllChat() {
      // Pusher.logToConsole = true
      const token = useJwt.getToken()

      const pusher = new Pusher('55454367d4f3d3b951b7', {
        cluster: 'ap1',
        authEndpoint: `${process.env.VUE_APP_API_URL}/v1/broadcasting/auth`,
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      })

      this.channelAllChat = pusher.subscribe('private-room-chat-adviser-all')

      this.channelAllChat.bind('client-typing', data => {
        if (data.user_id === this.$store.state.auth.userData.id) {
          return
        }

        this.setOtherTyping(data.user_id)
      })

      this.channelAllChat.bind('new-message', data => {
        if (!data || !data.message) {
          return
        }

        const { message } = data

        // find room and replace the latest message to current one
        const rooms = [...this.$store.state.chat.rooms]
        const indexOfRoomChat = rooms.findIndex(item => item.id === message.data.room_chat_id)

        if (message.type === 'new-chat' && indexOfRoomChat !== -1) {
          rooms[indexOfRoomChat].last_chat = message.data
          rooms.unshift(rooms.splice(indexOfRoomChat, 1)[0])
          this.$store.commit('chat/SET_ROOMS', rooms)
        } else if (message.type === 'new-chat' && indexOfRoomChat === -1) {
          this.$store.dispatch('chat/getRooms')
        }

        if (message.type === 'new-pending-chat') {
          // console.log('pending-chat')

          this.pushChat({
            pending_chat_id: message.data.id,
            room_chat_id: message.data.room_chat_id,
            reply_for_chat_id: message.data.reply_for_chat_id,
            sender_id: null,
            is_auto_answered: true,
            message: message.data.message,
            read_at: null,
            received_at: null,
            created_at: null,
            pending: true,
          })
        } else if (message.type === 'new-chat') {
          this.pushChat(message.data)
        }
      })
    },
    async subscribeChannel() {
      if (!this.activeRoom) {
        return
      }

      // Pusher.logToConsole = true
      const token = useJwt.getToken()

      const pusher = new Pusher('55454367d4f3d3b951b7', {
        cluster: 'ap1',
        authEndpoint: `${process.env.VUE_APP_API_URL}/v1/broadcasting/auth`,
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      })

      this.channel = pusher.subscribe(`private-room-chat-adviser-${this.activeRoom.user_1.id}`)
      this.sendOnlineEvent() // not working

      this.channel.bind('new-message', data => {
        if (!data || !data.message) {
          return
        }

        const { message } = data
        // console.log('message', message)

        if (message.type === 'new-pending-chat') {
          // console.log('pending-chat')

          this.pushChat({
            pending_chat_id: message.data.id,
            room_chat_id: message.data.room_chat_id,
            reply_for_chat_id: message.data.reply_for_chat_id,
            sender_id: null,
            is_auto_answered: true,
            message: message.data.message,
            read_at: null,
            received_at: null,
            created_at: null,
            pending: true,
          })
        } else if (message.type === 'new-chat') {
          this.pushChat(message.data)
        }
      })
    },
    pushChat(data) {
      const messages = [...this.$store.state.chat.messages]

      // this.$nextTick(() => {
      //   this.scrollToBottomInChatLog()
      // })

      if (messages.length) {
        // console.log(data)

        let index = messages.findIndex(item => item.pending_chat_id === data.pending_chat_id)

        if (index !== -1 && data.is_auto_answered && data.created_at) {
          messages[index] = data
          // console.log('==========1=========')
          this.$store.commit('chat/SET_MESSAGES', messages)
          return
        }

        index = messages.findIndex(item => item.pending_chat_id === data.pending_chat_id)

        if (index !== -1 && data.is_auto_answered) {
          messages.splice(index, 1)
          messages.unshift(data)
          // console.log('==========7=========')
          this.$store.commit('chat/SET_MESSAGES', messages)
          return
        }

        // find index of message with same uuid, if not found, push as a new message
        index = messages.findIndex(item => item.uuid === data.uuid)

        // console.log('push-chat', index, messages, data.message)

        if (index !== -1) {
          messages[index] = data
          // console.log('==========2=========')
          this.$store.commit('chat/SET_MESSAGES', messages)
          return
        }

        // // TODO: workaround
        // index = messages.findIndex(item => item.id && item.id === data.id)
        //
        // if (index !== -1) {
        //   return
        // }

        messages.unshift(data)
        // console.log('==========3=========')
        this.$store.commit('chat/SET_MESSAGES', messages)
      }
    },
    cancelReply(data) {
      // console.log(data)

      const messages = [...this.$store.state.chat.messages]

      if (messages.length) {
        // find message that doesn't have id means it's not sent yet
        const index = messages.findIndex(item => item.pending_chat_id === data.pending_chat_id)
        const item = messages[index]

        // console.log('cancel-reply', index, messages, data.message)

        if (index !== -1) {
          messages.splice(index, 1)
          // console.log('==========4=========')
          this.$store.commit('chat/SET_MESSAGES', messages)
          this.$store.dispatch('chat/cancelReply', data.pending_chat_id)
            .catch(() => {
              messages.unshift(item)
              // console.log('==========5=========')
              this.$store.commit('chat/SET_MESSAGES', messages)
            })
        }
      }
    },
    sendReply() {
      if (!this.pendingChat || !this.pendingChat.id) {
        return
      }

      // console.log('sendReply')
      this.$store.dispatch('chat/sendReply', this.pendingChat.id)
    },
    send() {
      if (!this.text) {
        return
      }

      const messages = [...this.$store.state.chat.messages]

      const uuid = uuidv4().replace(/-/g, '')

      const data = {
        uuid,
        message: this.text,
        created_at: Date(),
        sender_id: this.$store.state.auth.userData.id,
      }

      messages.unshift(data)

      // find room and replace the latest message to current one
      const rooms = [...this.$store.state.chat.rooms]
      const indexOfRoomChat = rooms.findIndex(item => item.id === this.$store.state.chat.activeRoom.id)

      if (indexOfRoomChat !== -1) {
        rooms[indexOfRoomChat].last_chat = data
        rooms.unshift(rooms.splice(indexOfRoomChat, 1)[0])
        this.$store.commit('chat/SET_ROOMS', rooms)
      }

      // console.log('==========6=========')
      this.$store.commit('chat/SET_MESSAGES', messages)
      this.$store.dispatch('chat/sendMessage', {
        uuid,
        message: this.text,
      })

      this.text = ''
    },
    sendTypingEvent(value) {
      if (value.length > 0) {
        this.channel.trigger('client-typing', {
          user_id: this.$store.state.auth.userData.id,
        })
      }
    },
    setOtherTyping(userId) {
      const typingUserIndex = this.otherTypingUsers.findIndex(item => item.id === userId)

      if (typingUserIndex !== -1) {
        clearTimeout(this.otherTypingUsers[typingUserIndex].timeout)
        this.otherTypingUsers.splice(typingUserIndex, 1)
      }

      this.otherTypingUsers.push({
        id: userId,
        timeout: setTimeout(() => {
          this.otherTypingUsers = this.otherTypingUsers.filter(item => item.id !== userId)
        }, 2000),
      })
    },
  },
  setup() {
    const CHAT_APP_STORE_MODULE_NAME = 'app-chat'

    // Register module
    if (!store.hasModule(CHAT_APP_STORE_MODULE_NAME)) store.registerModule(CHAT_APP_STORE_MODULE_NAME, chatStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CHAT_APP_STORE_MODULE_NAME)) store.unregisterModule(CHAT_APP_STORE_MODULE_NAME)
    })

    const { resolveAvatarBadgeVariant } = useChat()

    // Scroll to Bottom ChatLog
    const refChatLogPS = ref(null)
    const scrollToBottomInChatLog = () => {
      const scrollEl = refChatLogPS.value.$el || refChatLogPS.value
      scrollEl.scrollTop = scrollEl.scrollHeight
    }

    // ------------------------------------------------
    // Chats & Contacts
    // ------------------------------------------------
    const chatsContacts = ref([])
    const contacts = ref([])

    const fetchChatAndContacts = () => {
      store.dispatch('app-chat/fetchChatsAndContacts')
        .then(response => {
          chatsContacts.value = response.data.chatsContacts
          contacts.value = response.data.contacts
          // eslint-disable-next-line no-use-before-define
          profileUserDataMinimal.value = response.data.profileUser
        })
    }

    fetchChatAndContacts()

    // ------------------------------------------------
    // Single Chat
    // ------------------------------------------------
    const activeChat = ref({})
    const text = ref('')
    const openChatOfContact = room => {
      if (store.state.chat.activeRoom && room.id === store.state.chat.activeRoom.id) {
        return
      }

      // Reset send message input value
      text.value = ''
      store.commit('chat/SET_ACTIVE_ROOM', room)

      store.dispatch('chat/getChat', { roomId: room.id })
        // eslint-disable-next-line no-unused-vars
        .then(data => {
          // console.log(data)
          activeChat.value = {
            id: 2,
            userId: 1,
            unseenMsgs: 1,
            chat: [
              {
                message: 'Hai!',
                time: 'Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)',
                senderId: 11,
                role: 'system',
                hidden: true,
              },
              {
                message: 'Hallo!',
                time: 'Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)',
                senderId: 1,
                role: 'user',
                hidden: true,
              },
            ],
          }

          // Set unseenMsgs to 0
          // const contact = chatsContacts.value.find(c => c.id === roomId)
          // console.log(chatsContacts.value, contact)

          // if (contact) contact.chat.unseenMsgs = 0

          // Scroll to bottom
          // nextTick(() => {
          //   scrollToBottomInChatLog()
          // })
        })

      // if SM device =>  Close Chat & Contacts left sidebar
      // eslint-disable-next-line no-use-before-define
      mqShallShowLeftSidebar.value = false
    }
    const sendMessage = (senderId, message) => {
      const chatMessage = message || text.value
      if (!chatMessage) return
      const payload = {
        contactId: activeChat.value.contact.id,
        // eslint-disable-next-line no-use-before-define
        senderId: senderId || profileUserDataMinimal.value.id,
        message: chatMessage,
        role: senderId ? 'system' : 'user',
      }
      store.dispatch('app-chat/sendMessage', payload)
        .then(response => {
          const { newMessageData, chat } = response.data

          // ? If it's not undefined => New chat is created (Contact is not in list of chats)
          if (chat !== undefined) {
            activeChat.value = { chat, contact: activeChat.value.contact }
            chatsContacts.value.push({
              ...activeChat.value.contact,
              chat: {
                id: chat.id,
                lastMessage: newMessageData,
                unseenMsgs: 0,
              },
            })
          } else {
            // Add message to log
            activeChat.value.chat.chat.push(newMessageData)
          }

          // Reset send message input value
          text.value = ''

          // Set Last Message for active contact
          const contact = chatsContacts.value.find(c => c.id === activeChat.value.contact.id)
          contact.chat.lastMessage = newMessageData

          // Scroll to bottom
          // nextTick(() => {
          //   scrollToBottomInChatLog()
          // })
        })

      if (senderId) {
        // console.log(activeChat.value.chat.chat)

        let messages = activeChat.value.chat.chat.filter(item => !item.hidden)

        messages = messages.map(item => ({
          content: item.message,
          // eslint-disable-next-line no-nested-ternary
          role: item.role ? item : (item.senderId === 1 ? 'user' : 'system'),
        }))

        messages.push({
          content: chatMessage,
          role: 'user',
        })

        // console.log(messages)
        store.dispatch('app-chat/getReply', { messages })
          .then(response => {
            if (response.data.choices && response.data.choices.length && response.data.choices[0].message && response.data.choices[0].message.content) {
              // console.log(response.data.choices[0].message.content)
              sendMessage(null, response.data.choices[0].message.content)
            }
          })
      }
    }

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    // User Profile Sidebar
    // ? Will contain all details of profile user (e.g. settings, about etc.)
    const profileUserData = ref({})
    // ? Will contain id, name and avatar & status
    const profileUserDataMinimal = ref({})

    const shallShowUserProfileSidebar = ref(false)
    const showUserProfileSidebar = () => {
      store.dispatch('app-chat/getProfileUser')
        .then(response => {
          profileUserData.value = response.data
          shallShowUserProfileSidebar.value = true
        })
    }

    // Active Chat Contact Details
    const shallShowActiveChatContactSidebar = ref(false)

    // UI + SM Devices
    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()
    const startConversation = () => {
      if (store.state.app.windowWidth < $themeBreakpoints.lg) {
        mqShallShowLeftSidebar.value = true
      }
    }

    return {
      // Filters
      // formatDate,

      // useChat
      resolveAvatarBadgeVariant,

      // Chat & Contacts
      chatsContacts,
      contacts,

      // Single Chat
      refChatLogPS,
      activeChat,
      text,
      openChatOfContact,
      sendMessage,

      // Profile User Minimal Data
      profileUserDataMinimal,

      // User Profile Sidebar
      profileUserData,
      shallShowUserProfileSidebar,
      showUserProfileSidebar,

      // Active Chat Contact Details
      shallShowActiveChatContactSidebar,

      // UI
      perfectScrollbarSettings,

      // UI + SM Devices
      startConversation,
      mqShallShowLeftSidebar,

      scrollToBottomInChatLog,
    }
  },
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
